import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { regionalOneInstance, testLessor } from '../../../../shared_elements/components';
export default class UtilsListInfo extends Component{
  constructor(props){
    super(props);
  }
  render(){
    return(
      <div className="mobile-asset-list">

      <div className="asset-listing-wrap utilization-history" style={{marginLeft:'0px'}} >
        <div className="asset-list-filter-sort">
          <Row className="filter-block">
            <Col><h6 style={{width:'130px'}}>Month</h6></Col>
            <Col><h6 style={{width:'120px'}}>Major Assembly</h6></Col>
            <Col><h6>Hours</h6></Col>
            <Col><h6>Cycles</h6></Col>
            <Col><h6>TSN <br/>( Hrs )</h6></Col>
            <Col><h6>CSN <br/>( Cycles )</h6></Col>
            <Col><h6>Present Location</h6></Col>
            <Col><h6>Serviceability</h6></Col>
            <Col><h6>Derate</h6></Col>
            {regionalOneInstance || testLessor ?<Col><h6>EGT Margin</h6></Col>:null}
            <Col sm={1}><h6 style={{  float: 'right' }}>Action</h6></Col>
          </Row>
        </div>
        {this.props.children}
      </div>
      </div>
    )
  }
}
